import { useGetFeedbackListSummaryByEql } from '@modules/oracle/hooks/useGetFeedbackListSummaryByEql';
import { useGetEQLExpression } from 'v2/core/repository/edge-server/eql/useGetEQLExpression';
import { ExpressionType } from 'v2/core/repository/eql/types';
import { QueryContainer } from 'v2/core/services/notebook/types';
import { useGetUser } from 'v2/core/services/user';

interface useGetFeedbackListSummaryByQueryContainerParams {
  queryContainer: QueryContainer;
  shouldGetSummaryOnDemand?: boolean;
  prompt?: string;
  timeoutDuration?: number;
}

export function useGetFeedbackListSummaryByQueryContainer({
  queryContainer,
  shouldGetSummaryOnDemand = false,
  prompt,
  timeoutDuration,
}: useGetFeedbackListSummaryByQueryContainerParams) {
  const {
    tenant: { id: tenantID },
  } = useGetUser();

  const { eql } = useGetEQLExpression({
    tenantID,
    eqlProps: {
      expressionType: ExpressionType.Records,
      aggregatePeriod: queryContainer.AggregatePeriod,
      dateRange: queryContainer.DateRange,
      whereClause: queryContainer.WhereClause,
    },
  });

  return useGetFeedbackListSummaryByEql({
    eql,
    shouldGetSummaryOnDemand,
    prompt,
    timeoutDuration,
  });
}
